import { AttendancePage } from './attendance/AttendancePage'
import { EmployeesPage } from './employees/EmployeesPage'
import { PermissionsPage } from './permissions/PermissionsPage'

/**
 * `manager-hr` — the staff, their attendance and what each of them may reach.
 *
 * Ported: employees, attendance, permissions. The module is complete.
 */
export const managerHrModule = {
  name: 'manager-hr',
  routes: [
    {
      path: '/employees',
      page: 'employees',
      guard: { permission: 'employees' },
      component: EmployeesPage,
    },
    {
      path: '/attendance',
      page: 'attendance',
      guard: { permission: 'attendance' },
      component: AttendancePage,
    },
    {
      // `main_admin` on read **and** write — `/settings/permissions` is the one settings controller whose
      // GET is not open to an `admin`. The `permissions_admin` flag this was gated on is held by `admin`
      // too in the restored data, so a permission gate would admit somebody the server refuses outright.
      // FB-001 called for this tightening once `manager-settings` swept the module; the route guards are
      // enforced now, so it matters.
      path: '/permissions',
      page: 'permissions',
      guard: { systemRoles: ['main_admin'] },
      component: PermissionsPage,
    },
  ],
} as const

export { AttendancePage, EmployeesPage, PermissionsPage }
// §9.32 — sidebar chrome rather than a route: the shell places it, this module owns it.
export { SidebarAttendance } from './attendance/SidebarAttendance'
export { phaseOf, type Phase } from './attendance/attendance-phase'
